import { Component, Inject, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { InternshipDetailsComponent } from './internship-details/internship-details.component';
import { CompanyInfo, Internship } from '../shared/dto/models-dto';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-company-modal',
  templateUrl: './company-modal.component.html',
  styleUrls: ['./company-modal.component.css'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatTableModule, MatIconModule, MatInputModule, MatTooltipModule, FormsModule, TranslateModule]
})
export class CompanyModalComponent {

  internships: Internship[];
  filteredInternships: Internship[];
  displayedColumns: string[] = ['internshipTitle', 'position', 'department', 'country', 'city','email', 'actions'];
  searchFilter: string = '';

  constructor(
    public dialogRef: MatDialogRef<CompanyModalComponent>,
    @Inject(MAT_DIALOG_DATA) public company: CompanyInfo,
    private dialog: MatDialog, private translate : TranslateModule
  ) {
    this.internships = this.company.availableInternships || [];
    this.filteredInternships = this.internships;
    this.updateDisplayedColumns();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateDisplayedColumns();
  }

  private updateDisplayedColumns() {
    if (typeof window !== 'undefined') {
      this.displayedColumns = window.innerWidth < 990
        ? ['internshipTitle', 'country', 'city', 'email', 'actions']
        : ['internshipTitle', 'position', 'department', 'country', 'city', 'email', 'actions'];
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  applyFilter(): void {
    if (!this.searchFilter) {
      this.filteredInternships = this.internships;
      return;
    }

    const filterValue = this.searchFilter.toLowerCase();
    this.filteredInternships = this.internships.filter(internship =>
      internship.internshipTitle.toLowerCase().includes(filterValue) ||
      internship.position.toLowerCase().includes(filterValue) ||
      internship.department.toLowerCase().includes(filterValue) ||
      (internship.country?.name || internship.city?.country?.name || '').toLowerCase().includes(filterValue) ||
      ((internship.city?.name || '').toLowerCase().includes(filterValue))
    );
  }

  

  clearFilters(): void {
    this.searchFilter = '';
    this.filteredInternships = this.internships;
  }

  viewDetails(internship: Internship): void {
    this.dialog.open(InternshipDetailsComponent, {
      width: '500px',
      maxHeight: '90vh',
      data: {
        internship: internship,
        company: this.company
      },
      panelClass: 'internship-details-dialog'
    });
  }

  contactCompany(internship: Internship): void {
    const subject = encodeURIComponent(`Internship Inquiry: ${internship.internshipTitle}`);
    const body = encodeURIComponent(
      `Dear ${this.company.name},\n\n` +
      `I am interested in the following internship opportunity:\n` +
      `- Title: ${internship.internshipTitle}\n` +
      `- Position: ${internship.position}\n` +
      `- Department: ${internship.department}\n` +
      `- Country: ${internship.country?.name ?? internship.city?.country?.name ?? 'N/A'}\n` +
      `- City: ${internship.city?.name ?? 'N/A'}\n` +
      `I would like to receive more information about this opportunity.\n\n` +
      `Best regards`
    );
    window.location.href = `mailto:${internship.email}?subject=${subject}&body=${body}`;
  }



  //nextPage() {
  //  if (this.internships.length <= this.page*2){
  //  }
  //  else{
  //  this.page++;
  //  this.indexInternships = this.internships.slice((this.page-1)*2, this.page*2);
  //  }
  //}
//
  //previousPage() {
  //  if (this.page == 1){
//
  //  }
  //  else{
  //  this.page--;
  //  this.indexInternships = this.internships.slice((this.page-1)*2, this.page*2);
  //  }
  //}

}
